const externalReportAction = {
    DELETE_REPORT : 'delete report',

    EDIT_REPORT : 'edit report',

    GENERATE_REPORT : 'generate report'

};

angular.module('gw-um-j2js')
    .constant('externalReportAction', externalReportAction);